 <div class="header"
      *ngIf="!(loading | async) && !!(selected | async)">
    <muni-gameday-market-ticker [market]="selected | async"
                       [showChange]="false"
                       [highlightName]="false">
    </muni-gameday-market-ticker>
</div>
<div class="header"
     *ngIf="!(loading | async) && !(selected | async)">
     No Data Available
</div> 
<div class="header"
     *ngIf="loading | async">
     Loading...
</div> 